import { render, staticRenderFns } from "./StockDestinationList.vue?vue&type=template&id=5db7c444"
import script from "./StockDestinationList.vue?vue&type=script&lang=js"
export * from "./StockDestinationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports